import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './AppShell.css';

export interface SidebarItemProps {
  to: string;
  labelKey: string;
  /** bootstrap-icons class, e.g. "bi-calendar2-event" */
  icon: string;
  /** If true, only matches the route exactly. */
  end?: boolean;
  /** Click handler — used by parent to close the phone drawer on selection. */
  onNavigate?: () => void;
}

const SidebarItem: React.FC<SidebarItemProps> = ({ to, labelKey, icon, end, onNavigate }) => {
  const { t } = useTranslation();
  return (
    <NavLink
      to={to}
      end={end}
      onClick={onNavigate}
      className={({ isActive }) =>
        `shell-sidebar-item${isActive ? ' shell-sidebar-item--active' : ''}`
      }
    >
      <i className={`bi ${icon}`} data-testid="sidebar-item-icon" aria-hidden="true" />
      <span className="shell-sidebar-item__label">{t(labelKey)}</span>
    </NavLink>
  );
};

export default SidebarItem;
